<template>
  <div>
    <div style="display: flex; align-items: flex-start">
      <sidebar style="margin-right: 20px; max-width: 200px" />
      <el-card style="width: 100%">
        <div
          slot="header"
          class="clearfix"
        >
          <span>Leltár jegyzőkönyvek</span>
          <el-button
            style="float: right; margin-top: -5px;"
            type="success"
            size="small"
            @click="$router.replace('/processes/stock-takings/stock-taking-reports/add')"
            icon="el-icon-plus"
            v-can="'stocktakingreport.create'"
          >
            Új leltár jegyzőkönyv
          </el-button>
        </div>
        <div v-loading="loading" style="min-height: 81px;">
          <table-filter
            v-if="filterConfig"
            :config="filterConfig"
            action="stockTakingReport/fetchAll"
          />
        </div>
        <stock-taking-report-list />
        <template v-if="$route.meta.showAddStockTakingReportDialog">
          <stock-taking-report-dialog
            type="add"
          />
        </template>
        <template v-if="$route.meta.showUpdateStockTakingReportDialog">
          <stock-taking-report-dialog
            :stock-taking-report-id="$route.params.id"
            type="update"
          />
        </template>
        <template v-if="$route.meta.showStockTakingReportViewDialog">
          <stock-taking-report-dialog
            :stock-taking-report-id="$route.params.id"
            type="view"
          />
        </template>
      </el-card>
    </div>
  </div>
</template>

<script>
  import StockTakingReportList from '../../../components/processes/stockTakings/stockTakingReports/List';
  import StockTakingReportDialog from '../../../components/processes/stockTakings/stockTakingReports/Dialog';
  import Sidebar from '../../../components/processes/stockTakings/Sidebar';
  import TableFilter from '../../../components/TableFilter';

  export default {
    components: {
      StockTakingReportDialog,
      StockTakingReportList,
      TableFilter,
      Sidebar,
    },
    data() {
      return {
        loading: false,
        filterConfig: null,
      };
    },
    async mounted() {
      this.loading = true;
      await this.setConfig();
      this.loading = false;
    },
    methods: {
      async setConfig() {
        let users = this.$store.getters['user/users'];
        let storages = this.$store.getters['storage/storages'];
        let stockTakingTools = await axios.get('api/stock-taking-tools/all');
        if(!storages.length) {
          this.$store.dispatch('storage/fetchAll');
          storages = this.$store.getters['storage/storages'];
        }
        if(!users.length) {
          this.$store.dispatch('user/fetchAll');
          users = this.$store.getters['user/users'];
        }
        this.filterConfig = [
          {
            type: 'dateRange',
            name: 'start_date',
            label: 'Leltározás kezdete',
            defaultSearch: true,
          },
          {
            type: 'dateRange',
            name: 'end_date',
            label: 'Leltározás vége',
          },
          {
            type: 'dateRange',
            name: 'rate_date',
            label: 'Leltárak kiértékelése',
          },
          {
            type: 'dateRange',
            name: 'close_report_deadline_date',
            label: 'Záró jegyzőkönyv határideje',
          },
          {
            type: 'dateRange',
            name: 'diff_accountant_deadline_date',
            label: 'Eltérések könyvelésének határideje',
          },
          {
            type: 'dateRange',
            name: 'diff_blame_deadline_date',
            label: 'Eltérések miatti felelősség megállapítása',
          },
          {
            type: 'dateRange',
            name: 'completion_date',
            label: 'Kelt',
          },
          {
            type: 'select',
            name: 'storage',
            options: storages,
            label: 'Raktár',
            labelCallback: storage => storage && `${storage.name}` || '',
            valueKey: 'id',
          },
          {
            type: 'select',
            options: users,
            name: 'responsible_user',
            label: 'Felelős',
            labelCallback: user => user && `${user.last_name} ${user.first_name} (@${user.username})` || '',
            valueKey: 'id',
          },
          {
            type: 'select',
            name: 'stock_tool',
            options: stockTakingTools,
            label: 'Készletek köre',
            labelCallback: stockTool => stockTool && `${stockTool.name}` || '',
            valueKey: 'id',
          },
          {
            type: 'select',
            name: 'other_tool',
            options: stockTakingTools,
            label: 'Egyéb eszközök köre',
            labelCallback: otherTool => otherTool && `${otherTool.name}` || '',
            valueKey: 'id',
          },
          {
            type: 'select',
            name: 'tangible_assets_tool',
            options: stockTakingTools,
            label: 'Tárgyi eszközök köre',
            labelCallback: tat => tat && `${tat.name}` || '',
            valueKey: 'id',
          },
          {
            type: 'select',
            name: 'strange_belongings_tool',
            options: stockTakingTools,
            label: 'Idegen tulajdon',
            labelCallback: sbt => sbt && `${sbt.name}` || '',
            valueKey: 'id',
          },
          {
            type: 'text',
            name: 'report_number',
            options: stockTakingTools,
            label: 'Leltár jegyzőkönyv',
          },
        ];
      },
    },
  };
</script>
